<section>
  <div class="header">
    <h1>{{ 'CHANGE_PASSWORD_FORM.HEADER' | translate }}</h1>
  </div>

  @if (form) {
    <astral-form [form]="form" [columns]="3" [tabletColumns]="2" [mobileColumns]="1" (formSubmit)="onSubmit()">
      <section class="astral-grid-full astral-section-surface astral-content-width astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input
            [control]="form.controls['password']"
            type="password"
            autocomplete="current-password"
          ></astral-input>
          <astral-input
            [control]="form.controls['newPassword']"
            type="password"
            autocomplete="new-password"
          ></astral-input>
          <astral-input
            [control]="form.controls['confirmNewPassword']"
            type="password"
            autocomplete="new-password"
          ></astral-input>
        </astral-layout-group>

        <div class="astral-form-actions astral-form-actions--start">
          <astral-button type="submit" variant="primary" labelKey="SAVE_BTN"></astral-button>
        </div>
      </section>
    </astral-form>
  }
</section>
